package com.veldekar.model

enum class NavPage(
    val title: String,
    val path: String,
    val order: Int,
    private val menuGroup: MenuGroup
) {
    HOME("Home", "/", 0, MenuGroup.PRIMARY),
    MAP("Map", "/map", 1, MenuGroup.PRIMARY),
    ALL_SESSIONS("All Sessions", "/log", 2, MenuGroup.SECONDARY),
    SPELLS("Spells", "/spells", 4, MenuGroup.SECONDARY),
    SESSION_BAR_CHART("Session Chart", "/session-chart", 10, MenuGroup.SECONDARY),
    SESSION_HEATMAP("Session Heatmap", "/session-heatmap", 11, MenuGroup.SECONDARY),
    ABOUT("About", "/about", 12, MenuGroup.PRIMARY);

    fun isPrimary(): Boolean = menuGroup == MenuGroup.PRIMARY
    fun isSecondary(): Boolean = menuGroup == MenuGroup.SECONDARY

    companion object {
        fun primary(): List<NavPage> = entries.filter { it.isPrimary() }.sortedBy { it.order }
        fun secondary(): List<NavPage> = entries.filter { it.isSecondary() }.sortedBy { it.order }
        fun all(): List<NavPage> = entries.sortedBy { it.order }
    }

    private enum class MenuGroup { PRIMARY, SECONDARY }
}
